// menuPermissions.js
export const menuPermissions = [
    {
      name: "dashboard_txt",
      value: 'manage_dashboard',
      reportGroups: [
        {
          name: "revenue_order_report_tab_txt",
          value: 'manage_dashboard.revenueorder',
          permissions: [
            { name: "view_txt",   value: 'manage_dashboard.revenueorder.view',   default: true  },
            { name: "export_btn_txt", value: 'manage_dashboard.revenueorder.export', default: false },
          ]
        },
        {
          name: "customer_report_tab_txt",
          value: 'manage_dashboard.customerreport',
          permissions: [
            { name: "view_txt",   value: 'manage_dashboard.customerreport.view',   default: true  },
            { name: "export_btn_txt", value: 'manage_dashboard.customerreport.export', default: false },
          ]
        },
        {
          name: "product_report_tab_txt",
          value: 'manage_dashboard.productreport',
          permissions: [
            { name: "view_txt",   value: 'manage_dashboard.productreport.view',   default: true  },
            { name: "export_btn_txt", value: 'manage_dashboard.productreport.export', default: false },
          ]
        },
        {
          name: "promo_report_tab_txt",
          value: 'manage_dashboard.promoreport',
          permissions: [
            { name: "view_txt",   value: 'manage_dashboard.promoreport.view',   default: true  },
            { name: "export_btn_txt", value: 'manage_dashboard.promoreport.export', default: false },
          ]
        },
        {
          name: "sector_report_tab_txt",
          value: 'manage_dashboard.sectorreport',
          permissions: [
            { name: "view_txt",   value: 'manage_dashboard.sectorreport.view',   default: true  },
            { name: "export_btn_txt", value: 'manage_dashboard.sectorreport.export', default: false },
          ]
        },
        {
          name: "price_band_report_tab_txt",
          value: 'manage_dashboard.pricebandreport',
          permissions: [
            { name: "view_txt",   value: 'manage_dashboard.pricebandreport.view',   default: true  },
            { name: "export_btn_txt", value: 'manage_dashboard.pricebandreport.export', default: false },
          ]
        },
        {
          name: "depot_report_tab_txt",
          value: 'manage_dashboard.depotreport',
          permissions: [
            { name: "view_txt",   value: 'manage_dashboard.depotreport.view',   default: true  },
            { name: "export_btn_txt", value: 'manage_dashboard.depotreport.export', default: false },
          ]
        },
        {
          name: "email_report_tab_txt",
          value: 'manage_dashboard.emailreport',
          permissions: [
            { name: "view_txt",   value: 'manage_dashboard.emailreport.view',   default: true  },
            { name: "export_btn_txt", value: 'manage_dashboard.emailreport.export', default: false },
          ]
        },
      ]
    },
    { 
      name: "products_txt", 
      value: 'manage_products',
      subPermissions: [
        { name: "view_txt", value: 'manage_products.view', default: true },
        { name: "edit_txt", value: 'manage_products.edit', default: false },
        { name: "act_deact_txt", value: 'manage_products.activate', default: false },
        { name: "depot_txt", value: 'manage_products.depot', default: false },
        { name: "export_active_priceband_txt", value: 'manage_products.export', default: false },
        { name: "product_import_txt", value: 'manage_products.productimport', default: false },
        { name: "priceband_import_txt", value: 'manage_products.pricebandimport', default: false },
      ]
    },
    // {
    //   name: "product_access_requests_txt",
    //   value: 'manage_product_access_request',
    //   subPermissions: [
    //     { name: "approve", value: 'manage_product_access_request.approve', default: false },
    //     { name: "export_btn_txt", value: 'manage_product_access_request.export', default: false }
    //   ]
    // },
    { 
      name: "free_product_setup_txt", 
      value: 'manage_freeproducts',
      subPermissions: [
        { name: "view_txt", value: 'manage_freeproducts.view', default: true },
        { name: "edit_txt", value: 'manage_freeproducts.edit', default: false }
      ]
    },
    { 
      name: "new_products_txt", 
      value: 'manage_newproducts',
      subPermissions: [
        { name: "view_txt", value: 'manage_newproducts.view', default: true },
        { name: "add_txt", value: 'manage_newproducts.add', default: false },
        { name: "edit_txt", value: 'manage_newproducts.edit', default: false },
        { name: "delete_txt", value: 'manage_newproducts.delete', default: false }
      ]
    },
    { 
      name: "promotion_banner_txt", 
      value:'manage_promotions',
      subPermissions: [
        { name: "view_txt", value: 'manage_promotions.view', default: true },
        { name: "add_txt", value: 'manage_promotions.add', default: false },
        { name: "edit_txt", value: 'manage_promotions.edit', default: false },
        { name: "delete_txt", value: 'manage_promotions.delete', default: false }
      ]
    },
    { 
      name: "promo_offer_txt", 
      value:'manage_promooffers',
      subPermissions: [
        { name: "view_txt", value: 'manage_promooffers.view', default: true },
        { name: "add_txt", value: 'manage_promooffers.add', default: false },
        { name: "edit_txt", value: 'manage_promooffers.edit', default: false },
        { name: "delete_txt", value: 'manage_promooffers.delete', default: false }
      ]
    },
    { 
      name: "customers_txt", 
      value: 'manage_customers',
      subPermissions: [
        { name: "view_txt", value: 'manage_customers.view', default: true },
        { name: "edit_txt", value: 'manage_customers.edit', default: false },
        { name: "reset_pass_lbl", value: 'manage_customers.resetpassword', default: false },
        { name: "act_deact_txt", value: 'manage_customers.activate', default: false },
        { name: "session_dlt_txt", value: 'manage_customers.delete', default: false },
        { name: "export_btn_txt", value: 'manage_customers.export', default: false },
        { name: "import_txt", value: 'manage_customers.import', default: false },
      ]
    },
    {
      name: "food_service_partner_txt",
      value: 'manage_foodservicepartners',
      subPermissions: [
        { name: "view_txt", value: 'manage_foodservicepartners.view', default: true },
        { name: "add_txt", value: 'manage_foodservicepartners.add', default: false },
        { name: "edit_txt", value: 'manage_foodservicepartners.edit', default: false },
        { name: "delete_txt", value: 'manage_foodservicepartners.delete', default: false },
        { name: "logs_txt" , value: 'manage_foodservicepartners.log', default: false },
        { name: "per_refresh_txt", value: 'manage_foodservicepartners.refresh', default: true },
        { name: "faq_reorder_txt", value: 'manage_foodservicepartners.reorder', default: false },
        { name: "export_btn_txt", value: 'manage_foodservicepartners.export', default: false }
      ]
    },
    { 
      name: "order_txt", 
      value: 'manage_orders',
      subPermissions: [
        { name: "view_txt", value: 'manage_orders.view', default: true },
        { name: "logs_txt", value: 'manage_orders.logs', default: false },
        { name: "per_refresh_txt", value: 'manage_orders.refresh', default: true },
        { name: "kitchen_orders_txt", value: 'manage_orders.kitchen', default: false },
        { name: "export_btn_txt", value: 'manage_orders.export', default: false } ,
      ]
    },
    { name: "food_solution_txt", value:'manage_foodsolutions'},
    { name: "stripe_payment_log_txt", value:'manage_stripelog'},
    { 
      name: "master_entry_txt", 
      value: 'manage_masterentry' ,
      subPermissions: [
        { name: "view_txt", value: 'manage_masterentry.view', default: true },
        { name: "add_txt", value: 'manage_masterentry.add', default: false },
        { name: "edit_txt", value: 'manage_masterentry.edit', default: false },
        { name: "delete_txt", value: 'manage_masterentry.delete', default: false },
      ]
    },
    { 
      name: "developement_chef_txt", 
      value:'manage_chefs',
      subPermissions: [
        { name: "view_txt", value: 'manage_chefs.view', default: true },
        { name: "add_txt", value: 'manage_chefs.add', default: false },
        { name: "edit_txt", value: 'manage_chefs.edit', default: false },
        { name: "delete_txt", value: 'manage_chefs.delete', default: false }
      ]
    },
    { 
      name: "head_office_txt", 
      value:'manage_ho',
      subPermissions: [
        { name: "view_txt", value: 'manage_ho.view', default: true },
        { name: "add_txt", value: 'manage_ho.add', default: false },
        { name: "edit_txt", value: 'manage_ho.edit', default: false },
        { name: "delete_txt", value: 'manage_ho.delete', default: false }
      ]
    },
    { 
      name: "add_users_txt", 
      value: 'manage_users',
      subPermissions: [
        { name: "view_txt", value: 'manage_users.view', default: true },
        { name: "add_txt", value: 'manage_users.add', default: false },
        { name: "edit_txt", value: 'manage_users.edit', default: false },
      ]
    },
    { 
      name: "add_roles_txt", 
      value: 'manage_roles',
      subPermissions: [
        { name: "view_txt", value: 'manage_roles.view', default: true },
        { name: "add_txt", value: 'manage_roles.add', default: false },
        { name: "edit_txt", value: 'manage_roles.edit', default: false },
        { name: "delete_txt", value: 'manage_roles.delete', default: false },
      ]
    },
    { 
      name: "email_campaign_txt", 
      value:'manage_emailcampaign',
      subPermissions: [
        { name: "view_txt", value: 'manage_emailcampaign.view', default: true },
        { name: "add_txt", value: 'manage_emailcampaign.add', default: false },
        { name: "edit_txt", value: 'manage_emailcampaign.edit', default: false },
        { name: "act_deact_txt", value: 'manage_emailcampaign.activate', default: false },
        { name: "delete_txt", value: 'manage_emailcampaign.delete', default: false },
        { name: "trigger_emails_txt", value: 'manage_emailcampaign.runemail', default: false },
        { name: "email_log_title_txt", value: 'manage_emailcampaign.logs', default: false },
        { name: "export_btn_txt", value: 'manage_emailcampaign.export', default: false },
      ]
    },
    { 
      name: "setting_txt", 
      value: 'manage_settings',
      subPermissions: [
        { name: "view_txt", value: 'manage_settings.view', default: true },
        { name: "add_txt", value: 'manage_settings.add', default: false },
        { name: "edit_txt", value: 'manage_settings.edit', default: false },
        { name: "delete_txt", value: 'manage_settings.delete', default: false },
      ]
    },
  ];